import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { createDefaultProfile } from '../hooks/useProfile';
import { WEIGHT_PROFILES } from '../data/weightProfiles';
const STORAGE_PROFILE_KEY = 'decidepro-user-profile-v2';
const STORAGE_WEIGHTS_KEY = 'decidepro-weight-profile-v1';
const AppContext = createContext(null);
export function AppProvider({ children }) {
    const [profile, setProfile] = useState(() => {
        try {
            const stored = localStorage.getItem(STORAGE_PROFILE_KEY);
            if (stored)
                return JSON.parse(stored);
        }
        catch { }
        return createDefaultProfile();
    });
    const [activeWeightProfile, setActiveWeightProfile] = useState(() => {
        try {
            const stored = localStorage.getItem(STORAGE_WEIGHTS_KEY);
            if (stored) {
                const parsed = JSON.parse(stored);
                return parsed;
            }
        }
        catch { }
        return WEIGHT_PROFILES[0];
    });
    useEffect(() => {
        localStorage.setItem(STORAGE_PROFILE_KEY, JSON.stringify(profile));
    }, [profile]);
    useEffect(() => {
        localStorage.setItem(STORAGE_WEIGHTS_KEY, JSON.stringify(activeWeightProfile));
    }, [activeWeightProfile]);
    const updateProfileAttribute = (id, value) => {
        setProfile(prev => ({
            ...prev,
            attributes: prev.attributes.map(attr => attr.attributeId === id ? { ...attr, value } : attr),
            updatedAt: new Date().toISOString(),
        }));
    };
    const updateWeightProfile = (id) => {
        const found = WEIGHT_PROFILES.find(p => p.id === id);
        if (found)
            setActiveWeightProfile(found);
    };
    const updateCustomWeights = (weights) => {
        setActiveWeightProfile(prev => ({
            ...prev,
            id: 'custom',
            name: 'Customizado',
            description: 'Peso personalizado',
            weights,
        }));
    };
    const resetProfile = () => {
        const fresh = createDefaultProfile();
        setProfile(fresh);
        localStorage.setItem(STORAGE_PROFILE_KEY, JSON.stringify(fresh));
    };
    return (_jsx(AppContext.Provider, { value: {
            profile,
            activeWeightProfile,
            updateProfileAttribute,
            updateWeightProfile,
            updateCustomWeights,
            resetProfile,
        }, children: children }));
}
export function useAppContext() {
    const ctx = useContext(AppContext);
    if (!ctx)
        throw new Error('useAppContext must be used within AppProvider');
    return ctx;
}
